// ** React Imports
import React, { lazy, Suspense } from "react";

// ** Router Components
import { BrowserRouter as AppRouter, Route, Routes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import Admins from "../views/Admins";
import AdminView from "../views/Admins/AdminView";
import CreateAdmin from "../views/Admins/CreateAdmin";
import SignIn from "../views/Auth/SignIn";
import SignUp from "../views/Auth/SignUp/SignUp";
import CartPerson from "../views/CartPerson";
import CartPersonView from "../views/CartPerson/CartPersonView";
import CreateCartPerson from "../views/CartPerson/CreateCartPerson";
import Carts from "../views/Carts";
import CartView from "../views/Carts/CartView";
import InventoryView from "../views/Carts/CartView/Inventory/InventoryView";
import InventoryItemView from "../views/Carts/CartView/Inventory/InventoryView/InventoryItemView";
import CreateCart from "../views/Carts/CreateCart";
import Commission from "../views/Configuration/Commission";
import Configuration from "../views/Configuration/ConfigureCartDevice";
import PaymentDashboard from "../views/Dashboard";
import OrderRefund from "../views/Payment/OrderRefund";
import ViewOrderRefund from "../views/Payment/OrderRefund/ViewOrderRefund";
import Payouts from "../views/Payment/Payouts";
import PayoutView from "../views/Payment/Payouts/PayoutViewModal/index";
import Profile from "../views/Profile";
import PromoCode from "../views/PromoCode";
import AddRestaurant from "../views/RestaurantManagment/AddRestaurant";
import Restaurants from "../views/RestaurantManagment/Restaurants";
import RestaurantView from "../views/RestaurantManagment/Restaurants/RestaurantView";
import RolesAndPermissions from "../views/RolesAndPermission";
import ProtectedRoute from "./protectedRoute";
import SuperAdminProtectedRoute from "./superAdminProctected";
import OrganizationList from "../views/Organization/OrgList";
import CreateOrg from "../views/Organization/CreateOrg";
import OrganizationView from "../views/Organization/DetailView";
import CustomerList from "../views/CustomerManagment/CustomerList";
import CustomerView from "../views/CustomerManagment/CustomerView";
import SuperAdminSales from "../views/Carts/CartView/Sales/SalesView";

const Error = lazy(() => import("../views/Error"));

const Router: React.FC = () => {
  return (
    <AppRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="*" element={<Error />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            {/* Protected super-admin routes */}
            <Route
              path="/super-admin/*"
              element={
                <SuperAdminProtectedRoute>
                  <MainLayout />
                </SuperAdminProtectedRoute>
              }
            >
              {/* Super-admin sub-routes here */}
            </Route>
            <Route path="/" index element={<PaymentDashboard />} />
            <Route path="/profile" element={<Profile />} />

            <Route path="/admins/admins-list" element={<Admins />} />
            <Route path="/admins/createAdmin" element={<CreateAdmin />} />
            <Route path="/admins/admins-list/view" element={<AdminView />} />
            {/*-----------------Restaurant Managment--------------- */}
            {/*-----------------Restaurant Managment - Restaurants--------------- */}
            <Route
              path="/restaurants/restaurants-list"
              element={<Restaurants />}
            />
            <Route
              path="/restaurants/restaurants-list/view"
              element={<RestaurantView />}
            />
            {/*-----------------Restaurant Managment - Restaurants--------------- */}
            {/*-----------------Restaurant Managment - Create Restaurant--------------- */}
            <Route
              path="/restaurants/create-restaurant"
              element={<AddRestaurant />}
            />
            {/*-----------------Restaurant Managment - Create Restaurant--------------- */}
            {/*-----------------Restaurant Managment--------------- */}

            {/*-----------------Carts Managment--------------- */}
            <Route path="/carts/carts-list" element={<Carts />} />
            <Route path="/carts/carts-list/view" element={<CartView />} />
            <Route
              path="/carts/carts-list/view/inventory-view"
              element={<InventoryView />}
            />
            <Route
              path="/carts/carts-list/view/inventory-view/item-view"
              element={<InventoryItemView />}
            />

              <Route
              path="/carts/carts-list/view/sales-view"
              element={<SuperAdminSales />}
            />
            {/*-----------------Cart Managment - Create Cart--------------- */}
            <Route
              path="/carts/carts-list/create-cart"
              element={<CreateCart />}
            />
            {/*-----------------Cart Managment - Create Cart--------------- */}
            {/*-----------------Cart Managment--------------- */}

            {/*-----------------Cart Managment - Create CartPerson--------------- */}
            <Route
              path="/cartpersons/cartperson-list"
              element={<CartPerson />}
            />
            <Route
              path="/cartpersons/cartperson-list/cartperson-view"
              element={<CartPersonView />}
            />
            <Route
              path="/cartpersons/cartperson-list/create-cartperson"
              element={<CreateCartPerson />}
            />
            <Route
              path="/configuration/deviceConfiguration"
              element={<Configuration />}
            />

            <Route path="/configuration/commission" element={<Commission />} />
            {/*-----------------Cart Managment - Create CartPerson--------------- */}

            {/*-----------------Customer Managment--------------- */}
           

            <Route path="/customers/customer-list" element={<CustomerList />} />

           <Route path="/customers/customer-list/:id" element={<CustomerView />} />


            {/*-----------------Customer Managment--------------- */}

            {/*-----------------Customer Management--------------- */}

            {/* <OrganizationList /> */}
            <Route
              path="/organizations/organization-list"
              element={<OrganizationList />}
            />

            <Route
              path="/organizations/organization-list/add-organization"
              element={<CreateOrg />}
            />

           <Route path="/organizations/organization-list/:id" element={<OrganizationView />} />
            {/*-----------------User Managment--------------- */}
            {/*-----------------Roles Managment--------------- */}
            <Route
              path="/roles-and-permissions/role-management"
              element={<RolesAndPermissions />}
            />
            {/*-----------------Roles Managment--------------- */}

            {/*-----------------Promo Code ------------------ */}
            <Route path="/promo-code" element={<PromoCode />} />
            {/*-----------------Promo Code ------------------ */}

            {/*----------------- Payment ------------------ */}
            <Route path="/payment" element={<PromoCode />} />

            <Route path="/payment/order-Refund" element={<OrderRefund />} />
            <Route
              path="/payments/view-order-refund"
              element={<ViewOrderRefund />}
            />

            <Route path="/payment/payout" element={<Payouts />} />
            <Route path="/payment/payout/view" element={<PayoutView />} />
            {/*----------------- Payment ------------------ */}
          </Route>
        </Routes>
      </Suspense>
    </AppRouter>
  );
};

export default Router;
